import * as React from "react";

interface IProps{
    progress: number
}

const ProjectProgressBar = (props: IProps) =>{
    return (
        <>
            <div style={{
                height: '30px',
                width: '90%',
                padding: 0,
                position: 'relative',
                border: '1px solid black',
                backgroundColor: 'lightgray',
                overflow: 'hidden'
            }}>
                <div style={{
                    height: '100%',
                    width: `${props.progress}%`,
                    backgroundColor: '#4CAF50',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    padding: 0
                }}></div>
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    color: 'black'
                }}>
                    {props.progress}%
                </div>
            </div>
        </>
    )
}

export default ProjectProgressBar
